import { render } from "./Balance.vue?vue&type=template&id=02fc8869&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=02fc8869&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fc8869"]])

export default __exports__